import { render, staticRenderFns } from "./RecentVisits.vue?vue&type=template&id=766558bc&scoped=true"
import script from "./RecentVisits.vue?vue&type=script&lang=js"
export * from "./RecentVisits.vue?vue&type=script&lang=js"
import style0 from "./RecentVisits.vue?vue&type=style&index=0&id=766558bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766558bc",
  null
  
)

export default component.exports